export default "__VITE_ASSET__DnGxuUW___"